import React, { useEffect, useState } from 'react';
import TopHeader from './TopHeader';
import BottomHeader from './BottomHeader';
import Cookies from "js-cookie";
import { initiateSocketConnection } from '../../config/socket';

const Header = () => {
  const [isActive, setIsActive] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [cookie, setCookie] = useState(null);

  useEffect(() => {
    initiateSocketConnection()
    let value = Cookies.get("customCid");
    if (value) {
      setCookie(value);
    }
  }, []);
  return (
    <div className="relative w-full">

      {/* <div className="md:relative static z-10 bg-teal-600">
        <TopHeader />
      </div> */}

      <div className="absolute md:top-5 top-5 left-4 right-4 md:left-0 md:right-0 z-50 md:px-10">
        <BottomHeader />
      </div>
    </div>
  );
};

export default Header;
